import * as React from 'react';
import { Button as ButtonPrimitive } from '@/features/ui/primitives/button';
import { cn } from '@/lib/utils';

interface ButtonProps extends React.ComponentPropsWithoutRef<typeof ButtonPrimitive> {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}

export const Button = React.forwardRef<React.ElementRef<typeof ButtonPrimitive>, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <ButtonPrimitive
        className={cn(className)}
        variant={variant}
        size={size}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';
